// lib
import { getDefaultKeyBinding } from 'draft-js'
import { KEYCODE_UP, KEYCODE_DOWN } from '@aytm/lib/common/const'
import {
  getNextRichTextContentElement,
  getPreviousRichTextContentElement
} from '@aytm/lib/rfd-ui/components/advanced/lib/draft-js/rich-text'

// plugin
export default function arrowNavigationPlugin(config = {}) {
  const { getEditorState } = config

  return {
    isFocusAtTheStart() {
      const editorState = getEditorState()
      const selectionState = editorState.getSelection()
      const anchorKey = selectionState.getAnchorKey()
      const currentContent = editorState.getCurrentContent()
      const currentContentBlock = currentContent.getBlockForKey(anchorKey)
      return (
        currentContent.getFirstBlock() === currentContentBlock &&
        0 === selectionState.getStartOffset() &&
        0 === selectionState.getEndOffset()
      )
    },
    isFocusAtTheEnd() {
      const editorState = getEditorState()
      const selectionState = editorState.getSelection()
      const anchorKey = selectionState.getAnchorKey()
      const currentContent = editorState.getCurrentContent()
      const currentContentBlock = currentContent.getBlockForKey(anchorKey)
      if (currentContent.getLastBlock() === currentContentBlock) {
        const textLength = (currentContentBlock.getText() || '').length
        return textLength == selectionState.getStartOffset() && textLength == selectionState.getEndOffset()
      }
      return false
    },
    keyBindingFn(event) {
      if (!event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
        if (KEYCODE_UP === event.keyCode && this.isFocusAtTheStart()) {
          return 'set-focus-to-previous'
        }
        if (KEYCODE_DOWN === event.keyCode && this.isFocusAtTheEnd()) {
          return 'set-focus-to-next'
        }
      }
      return getDefaultKeyBinding(event)
    },
    handleKeyCommand(command, _editorState, { _setEditorState }) {
      switch (command) {
        case 'set-focus-to-previous': {
          const prevEditorComponent = getPreviousRichTextContentElement()
          if (prevEditorComponent) {
            prevEditorComponent.focus()
            // move focus to the end of the previous editor
            setTimeout(() => {
              dispatchEvent(new CustomEvent('moveRichTextCursor', { detail: {} }))
            }, 0)
          }
          return 'handled'
        }
        case 'set-focus-to-next': {
          const nextEditorComponent = getNextRichTextContentElement()
          if (nextEditorComponent) {
            nextEditorComponent.focus()
          }
          return 'handled'
        }
        default: {
          return 'not-handled'
        }
      }
    }
  }
}
